import RiseApiAdapter from 'rise-ui/adapters/apis/rise-api.js';

import { service } from '@ember/service';

import ENV from 'rise-ui/config/environment.js';
import { parseJsonErrors, parseTextErrors } from 'rise-ui/utils/ajax-rise.js';
import { serializeQueryParams } from 'rise-ui/utils/serialize-query-params.js';

const matchOrder = /order(\[|%5b).+(]|%5d)/i;

/**
 * Base adapter for ember-data requests to API server
 */
export default class DataApiAdapter extends RiseApiAdapter {
  @service ssr;

  host = ENV.APP.API.DATA.URL;
  namespace = ENV.APP.API.DATA.NAMESPACE;

  coalesceFindRequests = true;

  sortQueryParams(obj) {
    let keys = Object.keys(obj);
    if (keys.length < 2) {
      return obj;
    }
    const order = [];
    keys = keys.filter(key => {
      const orderKey = matchOrder.test(key);
      if (orderKey) {
        order.push(key);
      }
      return !orderKey;
    });
    let result = {};
    let sortedKeys = keys.sort();
    const addParam = key => result[key] = obj[key];
    sortedKeys.forEach(addParam);
    order.forEach(addParam);
    return result;
  }

  findMany(store, type, ids, snapshots) {
    let url = this.buildURL(type.modelName, ids, snapshots, 'findMany');
    return this.ajax(url, 'GET', { data: { id: ids.join(','), itemsPerPage: 1000 } });
  }

  ajaxOptions(url, method, options) {
    const { data } = options;
    if (!this.useFetch || !data || !url
      || !(method === 'GET' || method === 'HEAD')
      || !Object.keys(data).length
    ) {
      return super.ajaxOptions(...arguments);
    }
    const queryParamDelimiter = url.indexOf('?') > -1 ? '&' : '?';
    url += `${queryParamDelimiter}${serializeQueryParams(data)}`;
    return super.ajaxOptions(url, method, { ...options, data: null });
  }

  async ajax(...args) {
    let response;
    try {
      response = await super.ajax(...args);
    } catch (e) {
      if (e instanceof SyntaxError) {
        parseTextErrors(e.payload);
      }
      throw e;
    }
    try {
      parseJsonErrors(response);
    } catch (e) {
      throw e;
    }
    return response;
  }
}
